import axiosInstance from "../../../../lib/axiosInstance";

const detailMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  return typeof detail === "string" ? detail : JSON.stringify(detail);
};

/**
 * Vecros-hosted ArduPilot builds. Contract lives in docs/backend-requests.md.
 * `boardId` comes from the bootloader, so the list can be narrowed to builds
 * that physically fit the board in the user's hand.
 */
export const listFirmwareBuilds = async ({ boardId, vehicle } = {}) => {
  try {
    const { data } = await axiosInstance.get("/firmware/builds", {
      params: { board_id: boardId, vehicle },
    });
    return data.builds || [];
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load firmware builds"));
  }
};

/**
 * Fetch the .apj bytes and check them against the digest the catalog advertised.
 * Firmware is the one payload where a silent truncation is worth a page of code
 * to catch — SubtleCrypto is built in, so it costs nothing.
 */
export const downloadFirmwareBuild = async (build) => {
  let buffer;
  try {
    const { data } = await axiosInstance.get(`/firmware/builds/${build.id}/download`, {
      responseType: "arraybuffer",
    });
    buffer = data;
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to download firmware"));
  }

  if (build.sha256) {
    const digest = await crypto.subtle.digest("SHA-256", buffer);
    const hex = Array.from(new Uint8Array(digest))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    if (hex !== build.sha256.toLowerCase()) {
      throw new Error("Downloaded firmware failed its checksum — refusing to flash it.");
    }
  }
  return buffer;
};
